import appTicket from "../../views/appSettings/ticket.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("ticket", {
    url: "ticket/:id",
    parent: "app",
    views: {
      view: {
        template: appTicket,
      },
    },
    reloadOnSearch: false,
    data: { title: "Ticket" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/ticket/ticket.urls.js